module.exports = __webpack_public_path__ + "img/gail_alex.92031bb3.svg";